import React from "react";
import { MetricsDashboardGraphTypeDisplayType } from "../../../__generated__/api";
import Select from "../../../components/select/Select";

const DISPLAY_OPTIONS = [
    { label: "Number", value: MetricsDashboardGraphTypeDisplayType.Number },
    { label: "Decimal", value: MetricsDashboardGraphTypeDisplayType.Float },
    { label: "Currency", value: MetricsDashboardGraphTypeDisplayType.Currency },
    { label: "Duration", value: MetricsDashboardGraphTypeDisplayType.Duration },
    { label: "Percent", value: MetricsDashboardGraphTypeDisplayType.Percentage },
];

export default function DisplayOptions({
    value, onChange,
}: {
    value: MetricsDashboardGraphTypeDisplayType;
    onChange: (format: MetricsDashboardGraphTypeDisplayType) => void;
}) {
    return (
        <Select
            options={DISPLAY_OPTIONS}
            value={DISPLAY_OPTIONS.find(
                row => row.value === value,
            )}
            onChange={row => onChange(row.value as MetricsDashboardGraphTypeDisplayType)}
        />
    );
}
